var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48629_716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.30156 0.986677L14.3953 13.1742C14.6227 13.6453 14.4258 14.2113 13.9559 14.4386C13.8293 14.4996 13.6922 14.5324 13.5516 14.5336H1.36406C0.841407 14.5289 0.420703 14.1011 0.425391 13.5785C0.426562 13.439 0.459375 13.3007 0.520313 13.1742L6.61406 0.986677C6.84961 0.520271 7.41914 0.333943 7.88438 0.56949C8.06484 0.660896 8.21016 0.80738 8.30156 0.986677Z",
    fill: "#F2A600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72344 1.84223L14.4422 13.2563C14.6566 13.6981 14.4715 14.2301 14.0297 14.4446C13.9137 14.5008 13.7859 14.5313 13.657 14.5336H2.23125C1.74258 14.529 1.35 14.1293 1.35469 13.6407C1.35586 13.5071 1.3875 13.3758 1.44609 13.2563L7.15313 1.84223C7.36289 1.40864 7.8832 1.227 8.3168 1.43559C8.49492 1.52231 8.63789 1.66528 8.72344 1.84223Z",
    fill: "#FFCC32"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.45781 3.98657C6.91875 3.98657 6.48516 4.42017 6.52031 4.92407L6.91875 10.5491C6.96328 10.8467 7.23984 11.053 7.5375 11.0084C7.77539 10.9733 7.96172 10.787 7.99687 10.5491L8.39531 4.92407C8.43047 4.42017 7.99687 3.98657 7.45781 3.98657Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45781 11.4866C7.06992 11.4866 6.75469 11.8018 6.75469 12.1897C6.75469 12.5776 7.06992 12.8928 7.45781 12.8928C7.8457 12.8928 8.16094 12.5776 8.16094 12.1897C8.16094 11.8018 7.8457 11.4866 7.45781 11.4866Z",
    fill: "#424242"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.45781 3.98657C6.91875 3.98657 6.48516 4.42017 6.52031 4.92407L6.91875 10.5491C6.96328 10.8467 7.23984 11.053 7.5375 11.0084C7.77539 10.9733 7.96172 10.787 7.99687 10.5491L8.39531 4.92407C8.43047 4.42017 7.99687 3.98657 7.45781 3.98657Z",
    fill: "url(#paint0_linear_48629_716)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45781 12.8928C7.06949 12.8928 6.75469 12.578 6.75469 12.1897C6.75469 11.8014 7.06949 11.4866 7.45781 11.4866C7.84614 11.4866 8.16094 11.8014 8.16094 12.1897C8.16094 12.578 7.84614 12.8928 7.45781 12.8928Z",
    fill: "url(#paint1_linear_48629_716)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72344 2.69769C8.86406 2.87347 11.2312 7.50238 11.2312 7.50238C11.2312 7.50238 11.4422 7.85394 11.1492 8.05316C10.8797 8.24066 10.6336 8.01801 10.5281 7.84223C10.4227 7.66644 8.27812 3.51801 8.19609 3.31879C8.12578 3.09965 8.175 2.86058 8.325 2.68597C8.47734 2.54535 8.62969 2.56879 8.72344 2.69769Z",
    fill: "#FFF170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.325 9.21436C11.1114 9.21436 10.9383 9.04122 10.9383 8.82764C10.9383 8.61406 11.1114 8.44092 11.325 8.44092C11.5386 8.44092 11.7117 8.61406 11.7117 8.82764C11.7117 9.04122 11.5386 9.21436 11.325 9.21436Z",
    fill: "#FFF170"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_48629_716",
    x1: 7.45781,
    y1: 3.78148,
    x2: 7.45781,
    y2: 13.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_48629_716",
    x1: 7.45781,
    y1: 4.2479,
    x2: 7.45781,
    y2: 13.4694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48629_716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "matrix(-1 0 0 1 15 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.6e42300a5680c04670ca5b66795c1b6c.svg";
export { ForwardRef as ReactComponent };